export default "__VITE_ASSET__CxwrtZ3s__"